import { useMutation, useQueryClient } from '@tanstack/react-query';
import { getSubdomain } from '@zealy/utils';
import { twitterAutomationKeys } from '../twitterAutomation.keys';
import { mapFrontendToBackend } from '../twitterAutomation.mapper';
import { createAutomation } from '../twitterAutomation.service';
export const useCreateAutomation = (subdomain = getSubdomain(), communityExternalAccountId) => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (data) => createAutomation(subdomain, mapFrontendToBackend(data, communityExternalAccountId)),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: twitterAutomationKeys.list(subdomain) });
        },
    });
};
